'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsFocused", {
    enumerable: true,
    get: function() {
        return _native.useIsFocused;
    }
});
const _native = require("./react-navigation/native");

//# sourceMappingURL=useIsFocused.js.map
